module.exports = __webpack_public_path__ + "static/media/BM_HelpManual.a1379da7.svg";